import { TranslocoService } from '@jsverse/transloco';
import { CurrencyFormatPipe } from '@app/pipes/currency-format.pipe';
import { Input, Directive } from '@angular/core';
import { AirValidationCondition } from '@app/entities/air-validation.response';

@Directive()
export abstract class ChangesPoliciesAbsractComponent {

  private readonly CHANGES_BEFORE: string = 'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.CHANGES_BEFORE';
  private readonly CHANGES_AFTER: string = 'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.CHANGES_AFTER';
  private readonly AIRLINE_CHARGES: string = 'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.AIRLINE_CHARGES';

  @Input()
  public flight: AirValidationCondition;

  constructor(
    public translateService: TranslocoService,
    public currencyFormat: CurrencyFormatPipe
  ) { }

  public buildLabelFareAmount(fare: number, currencyCode: string): string {
    return this.currencyFormat.transform(fare, currencyCode);
  }

  get labelForChangesBefore(): string {
    return this.translateService.translate(this.CHANGES_BEFORE);
  }

  get laberForChangesAfter(): string {
    return this.translateService.translate(this.CHANGES_AFTER);
  }

  get labelWithFares(): string {
    return this.translateService.translate(this.AIRLINE_CHARGES);
  }

  public capitalize(text: string): string {
    const firstLetter = text?.substring(0, 1)?.toUpperCase();
    return `${firstLetter}${text?.substring(1)}`;
  }

}
